import React from 'react';
import logo from '../Images/cart/Background.png'
import './Extrapart.css'

const Extrapart = () => {
    return (
        <div className='logo'>
            <div>
                <p>Welcome to EYE MASTER</p>
                <img src={logo} alt="" />
            </div>
        </div>
    );
};

export default Extrapart;